<app-navbar></app-navbar>
<!-- TODO: Regresarlo a -container-fluid -->
<div class="container-fluid">
  <router-outlet></router-outlet>
</div>